<template>
    <div class="row position-relative" ref="mainContent">
        <div class="col-12 px-0">
            <ul class="qf-dashboard-navigation">
                <li class="qf-active-nav">
                    <a href="#!" @click.prevent>
                        {{$ml.get('Brand_Owners')}}
                    </a>
                </li>
                <li v-if="loading">
                    <a @clisk.prevent>
                        <font-awesome-icon icon="spinner" class="fa-spin"/>
                    </a>
                </li>
                <li></li>
            </ul>
        </div>
        <div class="col-12">
            <div class="row align-items-center">
                <div class="col text-right flex-grow-1">
                    <a href="#!"
                       @click.prevent="changeSearchState"
                       v-if="!showSearch">
                        <font-awesome-icon icon="search"/>&nbsp;&nbsp;{{(searchField ===
                        '')?$ml.get('Search'):searchField}}</a>
                    <div class="form-group mb-0"
                         v-else>
                        <input type="text"
                               class="form-control form-control-sm qf-max-width-200 ml-auto"
                               v-model="searchField"
                               v-click-outside="changeSearchState"
                               ref="searchFieldRef">
                    </div>
                </div>
                <div class="col text-right flex-grow-0">
                    <a href="#!"
                       class="btn btn-outline-dark text-uppercase btn-sm"
                       @click.prevent="openOwnerModal(null)">
                        <font-awesome-icon icon="plus"/>&nbsp;&nbsp;{{$ml.get('add')}}
                    </a>
                </div>
            </div>
        </div>
        <div class="col-12 h2 pt-5 text-center" v-if="loading">
            <font-awesome-icon icon="spinner" size="2x" class="fa-spin"/>
        </div>
        <div class="col-12 pt-3" v-else>
            <div class="table-responsive">
                <table class="qf-owners-table table qf-table">
                    <thead>
                    <tr v-if="owners.length">
                        <th>
                            <div class="d-flex align-items-center">
                                <button type="button" @click.prevent="changeSort('name')"
                                        class="qf-sort-button qf-sort-order position-relative d-block">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (sortOwners.field==='name' && sortOwners.order === -1)}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (sortOwners.field==='name' && sortOwners.order === 1)}"/>
                                </button>
                                <button type="button" @click.prevent="changeSort('name')"
                                        class="qf-filter-button mx-1 d-block js-brand-filter"
                                        ref="filterByNameHead">
                                    {{$ml.get('Name')}}
                                </button>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex align-items-center">
                                <button type="button" @click.prevent="changeSort('address')"
                                        class="qf-sort-button qf-sort-order position-relative d-block">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (sortOwners.field==='address' && sortOwners.order === -1)}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (sortOwners.field==='address' && sortOwners.order === 1)}"/>
                                </button>
                                <button type="button" @click.prevent="changeSort('address')"
                                        class="qf-filter-button mx-1 d-block js-brand-filter"
                                        ref="filterByNameHead">
                                    {{$ml.get('address')}}
                                </button>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex align-items-center">
                                <button type="button" @click.prevent="changeSort('email')"
                                        class="qf-sort-button qf-sort-order position-relative d-block">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (sortOwners.field==='email' && sortOwners.order === -1)}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (sortOwners.field==='email' && sortOwners.order === 1)}"/>
                                </button>
                                <button type="button" @click.prevent="changeSort('email')"
                                        class="qf-filter-button mx-1 d-block js-brand-filter"
                                        ref="filterByNameHead">
                                    {{$ml.get('email')}}
                                </button>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex align-items-center">
                                <button type="button" @click.prevent="changeSort('phone')"
                                        class="qf-sort-button qf-sort-order position-relative d-block">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (sortOwners.field==='phone' && sortOwners.order === -1)}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (sortOwners.field==='phone' && sortOwners.order === 1)}"/>
                                </button>
                                <button type="button" @click.prevent="changeSort('phone')"
                                        class="qf-filter-button mx-1 d-block js-brand-filter"
                                        ref="filterByNameHead">
                                    {{$ml.get('phone')}}
                                </button>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex align-items-center">
                                <button type="button" @click.prevent="changeSort('vat')"
                                        class="qf-sort-button qf-sort-order position-relative d-block">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (sortOwners.field==='vat' && sortOwners.order === -1)}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (sortOwners.field==='vat' && sortOwners.order === 1)}"/>
                                </button>
                                <button type="button" @click.prevent="changeSort('vat')"
                                        class="qf-filter-button mx-1 d-block js-brand-filter"
                                        ref="filterByNameHead">
                                    {{$ml.get('VAT_Number')}}
                                </button>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex align-items-center">
                                <button type="button" @click.prevent="changeSort('brands_count')"
                                        class="qf-sort-button qf-sort-order position-relative d-block">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (sortOwners.field==='brands_count' && sortOwners.order === -1)}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (sortOwners.field==='brands_count' && sortOwners.order === 1)}"/>
                                </button>
                                <button type="button" @click.prevent="changeSort('brands_count')"
                                        class="qf-filter-button mx-1 d-block js-brand-filter"
                                        ref="filterByNameHead">
                                    {{$ml.get('Trademarks_owned')}}
                                </button>
                            </div>
                            <!--                            <div class="d-flex align-items-center justify-content-center">-->
                            <!--                                <button type="button"-->
                            <!--                                        class="mx-1 qf-sort-button qf-sort-order position-relative d-block">-->
                            <!--                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"/>-->
                            <!--                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"/>-->
                            <!--                                </button>-->
                            <!--                                <span>{{$ml.get('Trademarks_owned')}}</span>-->
                            <!--                            </div>-->
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td colspan="12" class="text-center h5 py-3" v-if="owners.length === 0">
                            {{$ml.get('no_results_found')}}
                        </td>
                    </tr>
                    <tr class="qf-h-60px" v-for="(owner, index) in filteredOwners" :key="index">
                        <td>{{owner.name}}</td>
                        <td>{{owner.address}}</td>
                        <td>{{owner.email}}</td>
                        <td>{{owner.phone}}</td>
                        <td>{{owner.vat}}</td>
                        <td>{{owner.brands_count}}</td>
                        <td>
                            <a href="#!" @click.prevent="openOwnerModal(owner)">
                                <font-awesome-icon icon="pen"/>
                            </a>
                        </td>
                        <td>
                            <a href="#!" @click.prevent="removeOwner(owner)">
                                <font-awesome-icon icon="trash-alt"/>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <b-modal id="add-owner-modal"
                 v-model="showOwnerModal"
                 :title="(selectedOwner.id === null)?$ml.get('Add_New_Owner'):$ml.get('Edit_Owner')"
                 :hide-footer="true">
            <add-owner :owner="selectedOwner"
                       @closeOwnersModal="closeOwnersModal"></add-owner>
        </b-modal>
        <b-modal id="remove-owner-modal"
                 v-model="showRemoveOwnerModal"
                 :title="$ml.get('Delete_Owner')"
                 :hide-footer="true">
            <remove-owner :owner="selectedOwner"
                          :owners="owners"
                          @closeOwnersModal="closeRemoveOwnerModal"></remove-owner>
        </b-modal>
    </div>
</template>

<script>
    import AddOwner from '../../common/AddOwner'
    import RemoveOwner from '../../common/RemoveOwner'
    import {clickOutside} from "../../../directives/clickOutside";

    export default {
        name: "OwnersList",
        components: {
            AddOwner, RemoveOwner
        },
        directives: {
            clickOutside
        },
        computed: {
            filteredOwners() {
                let filteredOwners = this.owners;
                let that = this;
                if (this.searchField !== '') {
                    filteredOwners = filteredOwners.filter(obj => {
                        let show = false
                        if (obj.name && obj.name.includes(this.searchField)) {
                            show = true
                        }
                        if (obj.address && obj.address.includes(this.searchField)) {
                            show = true
                        }
                        if (obj.phone && obj.phone.includes(this.searchField)) {
                            show = true
                        }
                        if (obj.email && obj.email.includes(this.searchField)) {
                            show = true
                        }
                        if (obj.vat && obj.vat.includes(this.searchField)) {
                            show = true
                        }
                        return show
                    })
                }
                if (that.sortOwners.field === 'brands_count') {
                    filteredOwners.sort((function (a, b) {
                        let nameA = a[that.sortOwners.field] ? a[that.sortOwners.field] : ''; // ignore upper and lowercase
                        let nameB = b[that.sortOwners.field] ? b[that.sortOwners.field] : ''; // ignore upper and lowercase
                        if (nameA < nameB) {
                            return -that.sortOwners.order;
                        }
                        if (nameA > nameB) {
                            return that.sortOwners.order;
                        }
                        return 0;
                    }));
                } else {
                    filteredOwners.sort((function (a, b) {
                        let nameA = a[that.sortOwners.field] ? a[that.sortOwners.field].toUpperCase() : ''; // ignore upper and lowercase
                        let nameB = b[that.sortOwners.field] ? b[that.sortOwners.field].toUpperCase() : ''; // ignore upper and lowercase
                        if (nameA < nameB) {
                            return -that.sortOwners.order;
                        }
                        if (nameA > nameB) {
                            return that.sortOwners.order;
                        }
                        return 0;
                    }));
                }
                return filteredOwners
            },
        },
        data() {
            return {
                owners: [],
                loading: false,
                showOwnerModal: false,
                showRemoveOwnerModal: false,
                removeOwnerId: -1,
                sortOwners: {
                    order: 1,
                    field: 'name'
                },
                showSearch: false,
                searchField: '',
                selectedOwner: {
                    id: null,
                    name: '',
                    address: '',
                    email: '',
                    phone: '',
                    vat: '',
                }
            }
        },
        beforeMount() {
            this.getOwners();
        },
        methods: {
            getOwners() {
                if (!this.loading) {
                    this.$store.dispatch('owners').then(response => {
                        this.owners = response;
                    });
                }
            },
            openOwnerModal(owner = null) {
                if (owner === null) {
                    this.selectedOwner = {
                        id: null,
                        name: '',
                        address: '',
                        email: '',
                        phone: '',
                        vat: '',
                    }
                } else {
                    this.selectedOwner = owner
                }
                this.showOwnerModal = true;
            },
            closeOwnersModal(owner = null) {
                if (owner !== null) {
                    this.getOwners()
                }
                this.showOwnerModal = false;
            },
            changeSort(field) {
                if (this.sortOwners.field !== field) {
                    this.sortOwners.field = field;
                    this.sortOwners.order = 1;
                } else {
                    this.sortOwners.order = (this.sortOwners.order === 1) ? -1 : 1;
                }
            },
            changeSearchState() {
                this.showSearch = !this.showSearch;
                if (this.showSearch) {
                    setTimeout(() => {
                        this.$refs.searchFieldRef.focus()
                    }, 100)
                }
            },
            removeOwner(owner) {
                this.selectedOwner = owner;
                this.showRemoveOwnerModal = true;
            },
            closeRemoveOwnerModal(owner = false) {
                if (owner) {
                    this.getOwners()
                }
                this.showRemoveOwnerModal = false;
            }
        }
    }
</script>

<style scoped>
    .qf-owners-table.table.qf-table thead tr th {
        font-size: 13px;
    }

    .qf-max-width-200 {
        max-width: 200px;
    }

    .qf-owners-table.table.qf-table > thead > tr > th:nth-child(5) > div {
        min-width: 100px;
    }
    .qf-owners-table.table.qf-table > thead > tr > th:nth-child(6) > div {
        min-width: 140px;
    }
</style>
